export class SchemaField {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "required",
            "baseName": "required",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "presencePct",
            "baseName": "presencePct",
            "type": "number",
            "format": ""
        },
        {
            "name": "distinctEstimate",
            "baseName": "distinctEstimate",
            "type": "number",
            "format": ""
        },
        {
            "name": "looksLike",
            "baseName": "looksLike",
            "type": "LooksLike",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaField.attributeTypeMap;
    }
    constructor() {
    }
}
